import { useState } from 'react';
import { useSelector } from 'react-redux';

import { Breadcrumbs, Tabs } from '@components';
import { LEAD_MANAGEMENT } from '@constants/routes';
import { RoleType } from '@features/team-management/constants';
import Head from '@layouts/head/Head';
import { TabPill } from 'types/tabs';

import { CalendarIntegrationCard } from '../components/lead-settings';
import LeadSquaredConfiguration from '../components/lead-settings/LeadSquaredConfiguration';
import { LeadSettingIds, leadSettingsTabs } from '../constants/leadSettings';

const LeadSettings = () => {
  const { rolesAndPermissions } = useSelector((state: any) => state.user);
  const isSalesAgent = rolesAndPermissions?.role === RoleType.SALES_AGENT;

  const filteredTabs = isSalesAgent
    ? leadSettingsTabs.filter(
        (tab) => tab.id !== LeadSettingIds.LEAD_CONFIGURATION
      )
    : leadSettingsTabs;

  const [selectedTab, setSelectedTab] = useState<TabPill>(filteredTabs[0]);
  const handleTabChange = (tab: TabPill) => {
    setSelectedTab(tab);
  };

  const breadcrumbs = [
    { name: 'Settings', path: LEAD_MANAGEMENT.LEAD_SETTINGS },
    { name: selectedTab.label, path: LEAD_MANAGEMENT.LEAD_SETTINGS }
  ];

  return (
    <div className="page bg-bgBase">
      <Head title="Settings" />
      <Breadcrumbs dynamicCrumbs={breadcrumbs} />
      <Tabs
        tabs={filteredTabs}
        selectedTab={selectedTab}
        onTabSelect={handleTabChange}
      />
      <div className="mt-6">
        {selectedTab.id === LeadSettingIds.CALENDAR_CONFERENCING && (
          <CalendarIntegrationCard />
        )}
        {selectedTab.id === LeadSettingIds.LEAD_CONFIGURATION && (
          <LeadSquaredConfiguration />
        )}
      </div>
    </div>
  );
};

export default LeadSettings;
